var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-section cl-container"},[_c('nice-stats',{attrs:{"graphData":_vm.testData,"labelData":_vm.labelData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }